<template>
  <div
    :id="
      message.author !== 'me' && message.type !== 'system' && message_id != '0'
        ? message_id
        : ''
    "
    class="sc-message"
  >
    <div
      class="sc-message--content"
      :class="{
        sent: message.author === 'me',
        received: message.author !== 'me' && message.type !== 'system',
        executive: message.author == 'executive',
        system: message.type === 'system',
      }"
    >
      <!-- Estructuras comunes:: mensajitos -->
      <div
        v-if="
          message.type === 'text' ||
            message.type === 'button' ||
            message.type === 'slider-button'
        "
        class="sc-message--box"
      >
        <TextMessage
          v-if="message.type === 'text'"
          :data="message.data"
        />
        <ButtonMessage
          v-if="message.type === 'button'"
          :data="message.data"
        />
        <SliderButtonMessage
          v-if="message.type === 'slider-button'"
          :data="message.data"
        />
        <!-- footer -->

        <div
          v-if="message.data.meta"
          class="sc-message--meta"
        >
          <!-- Reproduce audio cuando un mensaje es recibido -->
          <template
            v-if="
              message_id != '0' && message_id != null && message.author !== 'me'
            "
          >
            {{ playNewMessageAudio() }}
          </template>

          <!-- Habilita valoración sólo para mensajes desde IA/Ejecutivo-->
          <div v-if="message_id != null && !notFeedback && notFeedback != true && (message_id !== 0 || endFeedback ===true)">
            <div
              v-if="message.author !== 'me' && message.type !== 'system' && !message.score"
              class="calificacion-text-left"
            >
              <button
                id="btn-positivo"
                class="btn-calificacion"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 25.87 25.02"
                  class="img-btn-positivo"
                  @click="sendFeedback($event, true)"
                >
                  <path
                    fill="currentColor"
                    d="M24.82,12.05c.21-1.33-.34-2.68-1.4-3.45-.61-.43-1.31-.66-2.05-.66h-5.22v-3.73c0-1.65-.49-2.85-1.45-3.55-1.52-1.12-3.6-.48-3.68-.46-.3.09-.5.37-.5.68v4.31c0,3.31-3.87,4.45-4.02,4.5-.02,0-.03.02-.05.02-.24-.36-.65-.61-1.12-.61H1.33c-.73,0-1.33.6-1.33,1.33v11.63c0,.73.6,1.33,1.33,1.33h4c.37,0,.7-.15.94-.39.64.64,1.52,1.03,2.5,1.03h10.53c2.39,0,3.9-1.25,4.18-3.43l1.34-8.53ZM5.23,21.95H1.43v-11.43h3.8v11.43ZM23.41,11.83l-1.35,8.55v.02c-.18,1.46-1.11,2.2-2.76,2.2h-10.53c-1.17,0-2.11-.94-2.11-2.11v-9.41c.07,0,.14,0,.21-.02.2-.06,5.07-1.46,5.07-5.87V1.46c.52-.07,1.32-.09,1.92.35.57.43.86,1.23.86,2.4v4.45c0,.39.32.72.72.72h5.94c.44,0,.87.13,1.22.39.62.45.94,1.26.82,2.06h0ZM23.41,11.83"
                  />
                </svg>
              </button>
              <button
                id="btn-negativo"
                class="btn-calificacion btn-negativo"
              >
                <svg
                  id="Información"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 25.87 25.02"
                  class="img-btn-negativo"
                  @click="sendFeedback($event, false)"
                >
                  <path
                    fill="currentColor"
                    d="M23.48,3.43c-.28-2.18-1.8-3.43-4.18-3.43h-10.53c-.98,0-1.86.39-2.5,1.03-.24-.24-.57-.39-.94-.39H1.33C.6.64,0,1.24,0,1.97v11.63c0,.73.6,1.33,1.33,1.33h4c.47,0,.88-.24,1.12-.61.02,0,.03,0,.05.02.16.05,4.02,1.18,4.02,4.5v4.31c0,.31.2.58.5.68.09.02,2.16.66,3.68-.46.96-.7,1.45-1.9,1.45-3.55v-3.73h5.22c.74,0,1.45-.23,2.05-.66,1.06-.76,1.61-2.12,1.4-3.45l-1.34-8.53ZM5.23,13.49H1.43V2.06h3.8v11.43ZM23.41,12.19c.13.8-.2,1.61-.82,2.06-.35.26-.78.39-1.22.39h-5.94c-.39,0-.72.32-.72.72v4.45c0,1.17-.28,1.98-.86,2.4-.6.43-1.4.42-1.92.35v-3.72c0-4.41-4.87-5.82-5.07-5.87-.07-.02-.14-.02-.21-.02V3.53c0-1.17.94-2.11,2.11-2.11h10.53c1.65,0,2.58.74,2.76,2.2v.02l1.35,8.55h0ZM23.41,12.19"
                  />
                </svg>
              </button>
            </div>
            <div v-else-if="message.author !== 'me'">
              <span
                class="calificacion-text"
                :class="{'sc-positive-evaluation': message.score && message.score === '1', 'sc-negative-evaluation': message.score && message.score === '0'}"
              >Calificación enviada.</span>
            </div>
          </div>
          <div
            v-if="message.data.voice"
            class="sc-message--audio"
            @click="playVoice"
          >
            <v-icon name="play" />
          </div>
          <div class="padding-tp-hora">
            <!-- Hora -->
            {{ message.data.meta }}
          </div>
        </div>
      </div>

      <!-- Estructuras especiales -->
      <EmojiMessage
        v-else-if="message.type === 'emoji'"
        :data="message.data"
      />
      <FileMessage
        v-else-if="message.type === 'file'"
        :data="message.data"
      />
      <TypingMessage v-else-if="message.type === 'typing'" />
      <SystemMessage
        v-else-if="message.type === 'system'"
        :data="message.data"
      />
    </div>
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/play'
import TextMessage from './TextMessage.vue'
import SliderButtonMessage from './SliderButtonMessage.vue'
import ButtonMessage from './ButtonMessage.vue'
import FileMessage from './FileMessage.vue'
import EmojiMessage from './EmojiMessage.vue'
import TypingMessage from './TypingMessage.vue'
import SystemMessage from './SystemMessage.vue'
import chatIcon from './assets/chat-close.png'

export default {
  components: {
    'v-icon': Icon,
    TextMessage,
    SliderButtonMessage,
    ButtonMessage,
    FileMessage,
    EmojiMessage,
    TypingMessage,
    SystemMessage
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    chatImageUrl: {
      type: String,
      default: chatIcon
    },
    colors: {
      type: Object,
      required: true
    },
    authorName: {
      type: String
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      tumbsUp: require('@/assets/forms/positivo.png'),
      tumbsDown: require('@/assets/forms/negativo.png'),
      message_id: this.message._id,
      notFeedback: this.message.notFeedback,
      endFeedback: this.message.endFeedback

    }
  },
  methods: {
    playVoice () {
      const voice_audio = new Audio()
      voice_audio.src = this.message.data.voice
      voice_audio.type = 'audio/wav'
      voice_audio.autoplay = false
      voice_audio.play()
    },
    playNewMessageAudio () {
      if (window.protocol.channel.plugin_enabled_audio) {
        const voice_audio = new Audio()
        voice_audio.src = window.protocol.channel.plugin_audio_sound
        voice_audio.type = 'audio/wav'
        voice_audio.autoplay = true
      }
    },
    sendFeedback (event, feed) {
      /* Arma score */
      const elementselect = event.composedPath()
      const score = {
        chat_user_name: window.protocol.my.name,
        score: feed === true ? '1' : '0',
        chat_log_id: elementselect[7].id,
        endFeedback: this.message.endFeedback
      }

      /* Reemplaza texto */
      const mensajesPuntuacion = document.querySelectorAll(
        'div[id="' + score.chat_log_id + '"]'
      )

      // Para los casos de Respuestas en varios mensajes, estos al tener el mismo ID se usa querySelectorAll para obtener todos los
      // elementos, puesto que usar getElementById solo trae el primero. Despues, se recorre el arreglo y se encuentra el div en el que
      // estan almacenados los botones de Puntuacion.
      mensajesPuntuacion.forEach((mensajesPuntuacion) => {
        mensajesPuntuacion.children[0].childNodes[0].children[1].children[0].innerHTML = `<span class="calificacion-text ${feed ? 'sc-positive-evaluation' : 'sc-negative-evaluation'}">Calificación enviada.</span>`
      })

      /* Envia calificación */

      this.message.score = score.score
      window.protocol.eventScore(score)
    }
  }
}
</script>
<style lang="scss">
.sc-message--content.received .sc-message--data {
    color: #636363;
    background-color: #fff;
    padding: 10px 10px 10px 12px;
    border-radius: 15px 15px 0 0;
}

.sc-message {
    width: 340px;
    margin: auto;
    padding-bottom: 10px;
    display: flex;
}

.sc-message--content {
    width: 100%;
    display: flex;
}

.sc-message--content.sent {
    justify-content: flex-end;
}

.sc-message--content.system {
    justify-content: center;
}

.sc-message--content.sent .sc-message--avatar {
    display: none;
}

.sc-message--meta {
    font-size: 10px;
    margin-bottom: 0;
    text-align: right;
}

.sc-message--content.received .sc-message--meta {
    color: #636363;
    padding: 5px 10px;
}

.sc-message--audio {
    margin: 0px;
    float: left;
    cursor: pointer;
}

@media (max-width: 450px) {
    .sc-message {
        width: 80%;
    }
}

.sc-message--box {
    min-width: 140px;
    padding: 5px 8px;
    border-radius: 15px 15px 15px 0;
    font-size: 15px;
    line-height: 1.4;
    -webkit-font-smoothing: subpixel-antialiased;
    width: 100%;
}

.sc-message--content.sent .sc-message--box {
    color: #fff;
    background-color: #4067aa;
    max-width: calc(100% - 120px);
    word-wrap: break-word;
    border-radius: 10px 10px 0 10px;
    padding: 10px 10px 10px 12px;
    -webkit-box-shadow: 4px 4px 5px 0px rgba(214, 214, 214, 0.69);
    -moz-box-shadow: 4px 4px 5px 0px rgba(214, 214, 214, 0.69);
    box-shadow: 4px 4px 5px 0px rgba(214, 214, 214, 0.69);
    margin: 10px 10px 0px 0;
}

.sc-message--box code {
    font-family: "Courier New", Courier, monospace;
}

.sc-message--slide-subtitle {
    font-weight: 600;
    padding-left: 10px;
}

.sc-message--content.received .sc-message--box {
    color: grey;
    font-size: 15px;
    margin: 20px 0px 0px 10px;
    background-color: #fff;
    margin-right: 30px;
    word-wrap: break-word;
    border-radius: 10px 10px 10 0;
    -webkit-box-shadow: 4px 4px 5px 0px rgba(214, 214, 214, 0.69);
    -moz-box-shadow: 4px 4px 5px 0px rgba(214, 214, 214, 0.69);
    box-shadow: 4px 4px 5px 0px rgba(214, 214, 214, 0.69);
    padding: 0px 0px 0px 0px;
}

.sc-message--content.executive .sc-message--box {
    font-size: 15px;
    margin: 20px 0px 0px 10px;
    background-color: #e2e2e2;
    margin-right: 30px;
    word-wrap: break-word;
    border-radius: 10px 10px 10 0;
    box-shadow: 0 5px 20px 0px rgba(148, 149, 150, 0.3);
    padding: 0px 0px 0px 0px;
}

.sc-message--content.executive .sc-message--meta {
    color: #636363;
    padding: 5px 10px;
}

.sc-message--content.executive .sc-message--box .sc-message--data {
    background-color: #e2e2e2;
    padding: 5px 10px;
    color: #0c4e84;
}

.sc-message--slide-title {
    list-style-type: none;
    color: #336195;
    font-size: 15px;
    margin: 13px 10px 5px 10px;
    font-weight: bold;
}

.sc-message--slide-text {
    color: grey;
    margin: 0 10px 10px 10px;
}

.sc-message--button-hr {
    height: 1px;
    border: 0;
    background-color: #d8d9da;
    width: 100%;
    outline: none;
}

.sc-message--data a.chatLink.chatLink-phone {
    pointer-events: none;
    text-decoration: none;
    color: currentColor;
    cursor: default;
}

.btn-calificacion {
    width: 23px;
    height: 23px;
    margin: -3px 4px 7px 0;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    text-transform: uppercase;
    float: left;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
}

#btn-positivo {
    background-color: #7fb535;
}

#btn-positivo:hover {
    opacity: 0.7;
}

#btn-positivo:focus {
    background-color: #7fb535;
}

.btn-negativo {
    background-color: #c23b3b;
}

.btn-negativo:hover {
    opacity: 0.7;
}

.btn-negativo:focus {
    background-color: #c23b3b;
}

.calificacion-text {
    width: 90px;
    border: solid 1px;
    border-radius: 5px;
    padding: 2px 3px;
    font-size: 9px;
    margin: 1px 4px 7px 0;
    float: left;
    text-align: center;
}

.padding-tp-hora {
    padding-top: 3px;
}

.calificacion-text-left {
    text-align: left;
}

button:focus {
    outline: 0 !important;
}

.img-btn-positivo {
    width: 14px;
    height: auto;
    margin: -2px;
}

.img-btn-negativo {
    width: 14px;
    height: auto;
    margin: -2px;
}

button {
    border-width: 0;
    border-style: none;
    border-color: none;
}

.sc-message--pdf-container {
  margin-top: 5px;
  width: 100%;
  text-align: center;
}

.sc-message--pdf-container img {
  display: block;
  margin: auto;
  width: 35px;
  height: 35px;
  margin-bottom: 5px;
  margin-top: 5px;
}

.sc-message--download-button {
  padding: 6px;
  min-width: 100px;
  border-radius: 20px;
  margin-top: 5px;
  background-color: transparent;
  cursor: pointer;
}

.sc-positive-evaluation {
  border-color: #7fb535;
  color: #7fb535;
}

.sc-negative-evaluation {
  border-color: #c23b3b;
  color: #c23b3b;
}
</style>
